import { render, staticRenderFns } from "./PantallaConfirmacion.vue?vue&type=template&id=227c3006"
import script from "./PantallaConfirmacion.vue?vue&type=script&lang=js"
export * from "./PantallaConfirmacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports